import React, { useState, useEffect, useCallback } from "react";
import LoadingOverlay from "react-loading-overlay";
import axios from "../../../axios/axios";
import { message } from "antd";
import { Form, Button } from "react-bootstrap";
import { HeaderTwoLogo, ticket_icon, island, deco, bg_c } from "../../../assets/images";
import './download-print.css';
import { useParams } from "react-router-dom";
import { backImage } from "../../../assets/images";
import { QRCodeSVG } from "qrcode.react";

const DownloadTravelCertificateNew = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const id = queryParams.get("id");

  const [isLoading, setIsLoading] = useState(false);
  const [certificateDetails, setCertificateDetails] = useState({});
  const [userDetails, setUserDetails] = useState({});
  const [certificateChangeLogo, setCertificateChangeLogo] = useState('');
  const [previewImage, setPreviewImage] = useState('');
  const [logoVisible, setLogoVisible] = useState(true);
  const [referCode, setReferCode] = useState("");

  const getCertificateDetails = useCallback(() => {
    setIsLoading(true);
    axios
      .get(`/get-travel-certificate/${id}`)
      .then((res) => {
        if (res.data.status) {
          setCertificateDetails(res.data.certificate_details);
          setTimeout(() => {
            setIsLoading(false);
            setTimeout(() => {
              // printDocument();
            }, 1000);
          }, 5000);
        } else {
          setIsLoading(false);
          message.error(res.data.message);
        }
      })
      .catch((err) => {
        console.error(err);
        setIsLoading(false);
        message.error("Something went wrong");
      });
  }, [id]);

  const getUserAffiliteDetails = useCallback((userId) => {
    setIsLoading(true);
    axios
      .get(`/user/get-user-id-by-affiliate-details/${userId}`)
      .then((res) => {
        // setIsLoading(false);
        let urlByCode = res.data.data.url.substring(res.data.data.url.lastIndexOf('/') + 1);
        setReferCode(urlByCode);
      })
      .catch((err) => {
        console.error(err);
        // setIsLoading(false);
        message.error("Something went wrong");
      });
  }, []);

  useEffect(() => {
    let uDetails = localStorage.getItem("userDetails");

    uDetails = uDetails ? JSON.parse(uDetails) : {};
    setUserDetails(uDetails);
    setPreviewImage(HeaderTwoLogo);
    if (uDetails.certificateOwnLogo) {
      setPreviewImage(uDetails.certificateOwnLogo);
    }

    getCertificateDetails();
    if (uDetails.id) {
      getUserAffiliteDetails(uDetails.id);
    }
  }, [id, getCertificateDetails, getUserAffiliteDetails]);

  const gotoBack = () => {
    window.location.href = '/print';
  };

  const printDocument = () => {
    let printContents = document.getElementById("print_content").innerHTML;

    document.body.innerHTML = printContents;

    window.print();

    window.close();
  };

  const logoUpload = async (e) => {
    e.preventDefault();
    if (certificateChangeLogo !== '') {
      setIsLoading(true);
      let data = new FormData();
      data.append("logo", certificateChangeLogo);
      data.append("userId", userDetails.id);
      data.append("source", userDetails.source);

      await axios
        .post(`/certificate-user-wise-logo`, data)
        .then((res) => {
          console.log(res);
          setIsLoading(false);
          if (res.data.status === true) {
            document.getElementById("logo-upload-form").reset();
            message.success(res.data.message);
            localStorage.setItem("userDetails", JSON.stringify(res.data.data));
            setUserDetails(res.data.data);
          } else {
            message.error(res.data.message);
          }
        })
        .catch((err) => {
          setIsLoading(false);
          console.log(err);
        });
    } else {
      message.error("Please upload your logo!");
    }
  };

  const removeLogo = (e) => {
    document.getElementById("logo-upload-form").reset();
    setLogoVisible(false);
    message.success('Logo remove successfully!');
  };

  return (
    <LoadingOverlay spinner active={isLoading} text="Loading...">
      <div className="row form-box">
        <div className="col-md-12">
          <Form id="logo-upload-form">
            <Form.Group controlId="formBasicEmail" className="col-md-6">
              <h5> Change logo</h5>
              <input
                type="file"
                name="myfile"
                onChange={(e) => {
                  console.log(e.target.files[0]);
                  setCertificateChangeLogo(e.target.files[0]);
                  if (e.target.files[0]) {
                    let pImg = URL.createObjectURL(e.target.files[0]);
                    setPreviewImage(pImg);
                    setLogoVisible(true);
                  }
                }}
              />
            </Form.Group>
            <Form.Group controlId="formBasicEmail" className="col-md-6 mt-3">
              <Button variant="primary" type="button" onClick={logoUpload}>
                Submit
              </Button>
              <Button variant="danger" className="ml-2" type="button" onClick={removeLogo}>
                Remove Logo
              </Button>
            </Form.Group>
          </Form>
        </div>

        <div className="col-md-12 mt-5">
          <Button variant="primary" className="float-left" type="button" onClick={gotoBack}>
            <img src={backImage} style={{ width: '20px' }} alt="" /> Back
          </Button>
          <Button variant="primary" className="float-right" type="button" onClick={printDocument}>
            Print
          </Button>
        </div>
      </div>

      {/* <div
          className="pdf_inner_inner_box1"
          id="print_content"
        // width="2480px"
        // height="3508px"
        >
          <div className="pdf_boxi1">
            <div className="create_pdfff1">
              <div className="pdf_banner">
                <img
                  src={certificateDetails.banner}
                  alt="Travel Certificate"
                />
              </div>
              <div className="pdf_content">
                <Row style={{ display: 'flex', flexWrap: 'wrap', marginRight: '-15px', marginLeft: '-15px' }}>
                  <Col lg="3" md="4" sm="12" className="padding_top30px">
                    <div className="pdf_price_img">
                      <img
                        src={certificateDetails.pricetag}
                        className="img-fluid"
                      />
                    </div>
                    <div className="scan_code code_scan">
                      <img
                        src={`https://chart.googleapis.com/chart?cht=qr&chl=${certificateDetails.qr_code}${userDetails?.name}/${certificateDetails.certificate_code}/${userDetails?._id}%2F&chs=180x180&choe=UTF-8&chld=L%7C2`}
                        className="img-fluid"
                      />
                    </div>
                    <div className="pdf_logo_img logo_pdf">
                      <img src={previewImage} className="img-fluid" />
                    </div>
                  </Col>
                  <Col lg="9" md="8" sm="12">
                    <div className="certificate_terms inner_termmmms">
                      <h2>Terms of the Certificate</h2>
                      <div
                        className="text-justify"
                        dangerouslySetInnerHTML={{
                          __html: certificateDetails.certificate_description,
                        }}
                      />

                      <h3>GET YOUR CERTIFICATE TODAY!</h3>
                      <div className="go_online online_go">
                        <p>Go Online: https://redeem.tripvalet.com/</p>
                        <p>Enter Referral Code: {userDetails?.name}</p>
                        <p>
                          Certificate Code:
                          {certificateDetails.certificate_code}
                        </p>
                      </div>
                    </div>
                  </Col>
                  <div className="foot_cont">
                    <p>
                      If you have general questions about your certificate
                      please email support@tripvalet.com Monday to Friday from
                      9am to 5pm Central Time.
                    </p>
                  </div>
                </Row>
              </div>
            </div>
          </div>
        </div> */}

      <div
        className="pdf_inner_inner_box1"
        id="print_content"
      >
        <div className="pdf_boxi1">
          <div className="create_pdfff1">

            <table
              role="presentation"
              cellSpacing="0"
              cellPadding="0"
              border="0"

              style={{
                background: `url(${island}) top center/contain no-repeat`,
                margin: '0 auto'
              }}
            >
              <tr>
                <td align="center">
                  <table
                    role="presentation"
                    cellSpacing="0"
                    cellPadding="0"
                    border="0"

                    className="email-container"
                    style={{
                      background: bg_c
                    }}
                  >

                    <tr>
                      <td style={{ padding: '44px 40px 36px', textAlign: 'center' }}>

                        <img src={previewImage} alt="TripValet Logo" width="250" />

                        <h2 style={{
                          fontFamily: "'Georgia', 'Times New Roman', serif",
                          fontSize: '30px',
                          fontWeight: 600,
                          textTransform: 'uppercase',
                          marginBottom: '5px',
                          color: '#ffffff',
                          textShadow: '-1px -1px 0 #1E2C68, 1px -1px 0 #1E2C68, -1px 1px 0 #1E2C68, 1px 1px 0 #1E2C68'
                        }}>

                        </h2>

                        <h2 style={{
                          fontFamily: "'Georgia', 'Times New Roman', serif",
                          fontSize: '54px',
                          fontWeight: 700,
                          margin: '0 0 5px 0',
                          color: '#18468F',
                          textShadow: '-1px -1px 0 #ffffff, 1px -1px 0 #ffffff, -1px 1px 0 #ffffff, 1px 1px 0 #ffffff'
                        }} dangerouslySetInnerHTML={{
                          __html: certificateDetails?.headingText,
                        }}>

                        </h2>

                        {/* <h2 style={{
                          fontFamily: "'Georgia', 'Times New Roman', serif",
                          fontSize: '36px',
                          fontWeight: 700,
                          margin: '0 0 20px',
                          fontStyle: 'italic',
                          color: '#18468F',
                          textShadow: '-1px -1px 0 #ffffff, 1px -1px 0 #ffffff, -1px 1px 0 #ffffff, 1px 1px 0 #ffffff'
                        }}>
                          All-Inclusive Vacation
                        </h2> */}

                        <table role="presentation" cellSpacing="0" cellPadding="0" border="0" align="center" style={{ margin: '0 auto' }}>
                          <tr>
                            <td bgColor="#0a2248" style={{ backgroundColor: '#1E2C68', borderRadius: '10px', padding: '8px 15px', textAlign: 'center' }}>
                              <span style={{
                                fontFamily: 'Arial, Helvetica, sans-serif',
                                fontSize: '15px',
                                fontWeight: 700,
                                color: '#ffffff',
                                letterSpacing: '0.3px',
                                whiteSpace: 'nowrap'
                              }}>
                                Enjoy accommodations valued up to
                                <span style={{ color: '#f5c842' }}>&nbsp;{certificateDetails?.accommodationsValue}</span>
                              </span>
                            </td>
                          </tr>
                        </table>

                        <img src={deco} alt="Decorative Element" style={{ margin: '20px 0 0 0' }} width="300" />

                      </td>
                    </tr>

                    <tr>
                      <td style={{ padding: '10px 30px', backgroundColor: '#ffffff' }}>
                        <h5 style={{
                          margin: '0 0 20px',
                          textAlign: 'center',
                          fontFamily: 'Arial, Helvetica, sans-serif',
                          fontSize: '20px',
                          textTransform: 'uppercase',
                          color: '#1253a4',
                          fontWeight: 700
                        }}>
                          Terms of the Certificate
                        </h5>

                        <p style={{
                          margin: 0,
                          textAlign: 'justify',
                          fontFamily: 'Arial, Helvetica, sans-serif',
                          fontSize: '15px',
                          lineHeight: 1.6,
                          color: '#1E2C68',
                          fontWeight: 600
                        }}
                          dangerouslySetInnerHTML={{ __html: certificateDetails?.certificate_description }}
                        >

                        </p>

                      </td>
                    </tr>

                    <tr>
                      <td style={{ padding: '0 30px', textAlign: 'center', backgroundColor: '#ffffff' }}>

                        <h2 style={{
                          margin: '0 0 10px',
                          fontFamily: 'Arial, Helvetica, sans-serif',
                          fontSize: '19px',
                          fontWeight: 700,
                          textTransform: 'uppercase',
                          color: '#b8860b'
                        }}>
                          Get Your Certificate Today!
                        </h2>

                        <table role="presentation" cellSpacing="0" cellPadding="0" border="0" align="center" style={{ margin: '0 auto 26px' }}>
                          <tr>
                            <td style={{ textAlign: 'center' }}>
                              <table role="presentation" cellSpacing="0" cellPadding="0" border="0" align="center">
                                <tr>
                                  <td style={{ paddingRight: '10px', verticalAlign: 'middle' }}>
                                    <img src={ticket_icon} alt="Ticket" width="40" height="40" />
                                  </td>
                                  <td style={{ verticalAlign: 'middle' }}>
                                    <h4 style={{
                                      fontFamily: 'Arial, Helvetica, sans-serif',
                                      fontSize: '18px',
                                      fontWeight: 700,
                                      color: '#1E2C68',
                                      margin: 0
                                    }}>
                                      ${certificateDetails?.certificateData?.certificatePrice} Non-refundable Activation fee
                                    </h4>
                                  </td>
                                </tr>
                                <tr>
                                  <td colSpan="2" style={{ textAlign: 'left', fontFamily: 'Arial, Helvetica, sans-serif', fontSize: '18px', fontWeight: 700, color: '#1E2C68', paddingBottom: '6px' }}>
                                    Go Online: {(certificateDetails?.isWhiteLevel) ? `https://redeem.viptravelreward.com/${referCode}` : `https://redeem.tripvalet.com`}
                                  </td>
                                </tr>
                                <tr>
                                  <td colSpan="2" style={{ textAlign: 'left', fontFamily: 'Arial, Helvetica, sans-serif', fontSize: '18px', fontWeight: 700, color: '#1E2C68', paddingBottom: '6px' }}>
                                    Enter Referral Code: {referCode}
                                  </td>
                                </tr>
                                <tr>
                                  <td colSpan="2" style={{ textAlign: 'left', fontFamily: 'Arial, Helvetica, sans-serif', fontSize: '18px', fontWeight: 700, color: '#1E2C68' }}>
                                    Certificate Code: {certificateDetails?.certificate_code}
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>

                    <tr>
                      <td style={{ padding: '0 30px 30px', textAlign: 'center', backgroundColor: '#ffffff' }}>
                        <p style={{ margin: '4px 0 0', fontFamily: 'Arial, Helvetica, sans-serif', fontSize: '18px', color: '#1E2C68' }}>
                          If you have general questions about your certificate please email<br />
                          {certificateDetails?.isWhiteLevel ? 'support@viptravelreward.com' : 'support@tripvalet.com'} Monday to Friday from 9am to 5pm Central Time.
                        </p>
                      </td>
                    </tr>

                  </table>
                </td>
              </tr>
            </table>

          </div>
        </div>
      </div>

      {/* <div
          className="pdf_inner_inner_box1"
          id="print_content"
        // width="2480px"
        // height="3508px"
        >
          <div className="pdf_boxi1">
            <div className="create_pdfff1">
              <div className="pdf_banner">
                <img
                  src={certificateDetails.banner}
                  alt="Travel Certificate"
                />
              </div>
              <div className="pdf_content">
                <Row>
                  <Col lg="3" md="4" sm="12" className="padding_top30px">
                    <div className="pdf_price_img">
                      <img
                        src={certificateDetails.pricetag}
                        className="img-fluid"
                      />
                    </div>
                    <div className="scan_code code_scan">
                      <img
                        src={`https://chart.googleapis.com/chart?cht=qr&chl=${certificateDetails.qr_code}${userDetails?.name}/${certificateDetails.certificate_code}/${userDetails?._id}%2F&chs=180x180&choe=UTF-8&chld=L%7C2`}
                        className="img-fluid"
                      />
                    </div>
                    <div className="pdf_logo_img logo_pdf">
                      <img src={previewImage} className="img-fluid" />
                    </div>
                  </Col>
                  <Col lg="9" md="8" sm="12">
                    <div className="certificate_terms inner_termmmms">
                      <h2>Terms of the Certificate</h2>
                      <div
                        className="text-justify"
                        dangerouslySetInnerHTML={{
                          __html: certificateDetails.certificate_description,
                        }}
                      />

                      <h3>GET YOUR CERTIFICATE TODAY!</h3>
                      <div className="go_online online_go">
                        <p>Go Online: https://redeem.tripvalet.com/</p>
                        <p>Enter Referral Code: {userDetails?.name}</p>
                        <p>
                          Certificate Code:
                          {certificateDetails.certificate_code}
                        </p>
                      </div>
                    </div>
                  </Col>
                  <div className="foot_cont">
                    <p>
                      If you have general questions about your certificate
                      please email support@tripvalet.com Monday to Friday from
                      9am to 5pm Central Time.
                    </p>
                  </div>
                </Row>
              </div>
            </div>
          </div>
        </div> */}
    </LoadingOverlay>
  );
};

export default DownloadTravelCertificateNew;
